import { render, staticRenderFns } from "./BattleResultStatsModal.vue?vue&type=template&id=81484596&scoped=true&lang=pug&"
import script from "./BattleResultStatsModal.vue?vue&type=script&lang=js&"
export * from "./BattleResultStatsModal.vue?vue&type=script&lang=js&"
import style0 from "./BattleResultStatsModal.vue?vue&type=style&index=0&id=81484596&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81484596",
  null
  
)

export default component.exports